import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import ImageModal from "./components/ImageModal.jsx";

import imageOne from "./images/image-product-1.jpg";
import imageOnelittle from "./images/image-product-1-thumbnail.jpg";
import imageTwo from "./images/image-product-2.jpg";
import imageTwolittle from "./images/image-product-2-thumbnail.jpg";
import imageThree from "./images/image-product-3.jpg";
import imageThreelittle from "./images/image-product-3-thumbnail.jpg";
import imageFour from "./images/image-product-4.jpg";
import imageFourlittle from "./images/image-product-4-thumbnail.jpg";

import plusIcon from "./images/icon-plus.svg";
import minusIcon from "./images/icon-minus.svg";
import cart from "./images/icon-cart.svg";
import MobileNavbar from "./components/MobileNavbar.jsx";
import leftArrow from "./images/icon-previous.svg";
import rightArrow from "./images/icon-next.svg";

const App = () => {
    const [count, setCount] = useState(0);
    const [items, setItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(imageOne);

    const title = "Fall Limited Edition Sneakers";

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const images = [imageOne, imageTwo, imageThree, imageFour];
    const smallImages = [
        imageOnelittle,
        imageTwolittle,
        imageThreelittle,
        imageFourlittle,
    ];

    const thumbnails = [
        imageOnelittle,
        imageTwolittle,
        imageThreelittle,
        imageFourlittle,
    ];

    const addItem = (count, title) => {
        const newItem = { image: imageOnelittle, count, title, price: 125 };
        if (count === 0) return;
        setItems((prevItems) => [...prevItems, newItem]);
        setCount(0);
    };

    const deleteItem = (index) => {
        setItems((prevItems) => prevItems.filter((_, i) => i !== index));
    };

    const openModal = (image) => {
        setCurrentImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="min-h-screen w-full flex flex-col items-center">
            <section className="container mx-auto max-w-[1110px] flex flex-col items-center">
                {windowWidth > 880 ? (
                    <Navbar
                        items={items}
                        setItems={setItems}
                        deleteItem={deleteItem}
                    />
                ) : (
                    <MobileNavbar
                        items={items}
                        setItems={setItems}
                        deleteItem={deleteItem}
                    />
                )}
                <div className="max-w-[1015px] w-full flex flex-col md:flex-row justify-center md:mt-[90px]">
                    <div className="md:max-w-[445px] w-full flex flex-col gap-8 mr-[125px]">
                        <div
                            id="bigImage"
                            className="flex flex-col relative z-10"
                        >
                            <img
                                src={currentImage}
                                alt="product"
                                className="md:max-w-[445px] h-auto md:rounded-[15px] relative"
                                onClick={() => openModal(currentImage)}
                            />
                            {windowWidth <= 880 && (
                                <>
                                    <div className="absolute left-4 top-1/2 transform -translate-y-1/2 rounded-full bg-white size-10 flex items-center justify-center cursor-pointer">
                                        <img
                                            src={leftArrow}
                                            alt="left arrow"
                                            onClick={() =>
                                                setCurrentImage(
                                                    images[
                                                        (images.indexOf(
                                                            currentImage
                                                        ) -
                                                            1 +
                                                            images.length) %
                                                            images.length
                                                    ]
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 rounded-full bg-white size-10 flex items-center justify-center cursor-pointer">
                                        <img
                                            src={rightArrow}
                                            alt="right arrow"
                                            onClick={() =>
                                                setCurrentImage(
                                                    images[
                                                        (images.indexOf(
                                                            currentImage
                                                        ) +
                                                            1) %
                                                            images.length
                                                    ]
                                                )
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="md:flex hidden w-full justify-between ">
                            {thumbnails.map((thumbnail, index) => (
                                <div
                                    key={index}
                                    className="relative cursor-pointer group"
                                    onClick={() =>
                                        setCurrentImage(images[index])
                                    }
                                >
                                    <img
                                        src={thumbnail}
                                        alt="product thumbnail"
                                        className="max-w-[88px] rounded-[10px]"
                                    />
                                    {images.indexOf(currentImage) === index && (
                                        <div className="absolute inset-0 bg-white opacity-75 rounded-[10px] border-2 border-[#FF7E1B]"></div>
                                    )}
                                    {images.indexOf(currentImage) !== index && (
                                        <div className="absolute inset-0 bg-white opacity-0 rounded-[10px] group-hover:opacity-50 transition-opacity"></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col md:mt-16 w-full p-6">
                        <p className="sneakerCompany">Sneaker Company</p>
                        <h1 className="title mt-6">{title}</h1>
                        <p className="navLink mt-8">
                            These low-profile sneakers are your perfect casual
                            wear companion. Featuring a durable rubber outer
                            sole, they'll withstand everything the weather can
                            offer.
                        </p>
                        <div className="flex md:flex-col items-center justify-between md:items-start md:justify-center gap-[10px] mt-6">
                            <div className="flex gap-4 items-center md:items-start">
                                <p className="price">$125.00</p>
                                <p className="flex items-center justify-center px-2.5 py-[2px] max-h-[27px] bg-[#1D2026] md:mt-1 rounded-[6px] discount">
                                    50%
                                </p>
                            </div>
                            <p className="lastPrice">$250.00</p>
                        </div>
                        <div className="flex flex-col md:flex-row mt-8 items-center gap-4 justify-between">
                            <div className="bg-[#F6F8FD] flex items-center gap-[45px] py-5 px-4 rounded-[10px] md:max-w-[157px] w-full justify-between">
                                <button
                                    aria-label="Decrease count"
                                    className="w-3 hover:cursor-pointer"
                                    onClick={() =>
                                        setCount((prevCount) =>
                                            Math.max(0, prevCount - 1)
                                        )
                                    }
                                >
                                    <img
                                        src={minusIcon}
                                        alt="minus icon"
                                        className="hover:fill-[#FFAB6A]"
                                    />
                                </button>
                                <p>{count}</p>
                                <button
                                    aria-label="Increase count"
                                    className="w-3 hover:cursor-pointer"
                                    onClick={() =>
                                        setCount((prevCount) => prevCount + 1)
                                    }
                                >
                                    <img
                                        src={plusIcon}
                                        alt="plus icon"
                                        className="hover:fill-[#FFAB6A]"
                                    />
                                </button>
                            </div>

                            <button
                                className="flex gap-4 justify-center items-center justify-self-end md:max-w-[272px] bg-[#FF7E1B] hover:bg-[#FFAB6A] rounded-[10px] w-full h-[64px] md:h-full buttonText"
                                onClick={() => addItem(count, title)}
                            >
                                <img
                                    src={cart}
                                    alt="cart icon"
                                    style={{
                                        filter: "brightness(0) saturate(100%)",
                                    }}
                                />
                                <p>Add to cart</p>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {windowWidth > 880 && (
                <ImageModal
                    isOpen={isModalOpen}
                    image={currentImage}
                    onClose={closeModal}
                    images={images}
                    smallImages={smallImages}
                    setImage={setCurrentImage}
                />
            )}
        </div>
    );
};

export default App;
